<template>
    <div class="container-fluid mb-5 ps-5">
        <div class="row">
            <div class="col">
                <img @click="$emit('go-back-event')" src="../../assets/back-button.svg" class="img-fluid cursor-pointer" width="32" alt="">
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col text-center">
                <h1 class="thin-text mb-5 fs-3">Le figure contrattuali</h1>
            </div>
        </div>
    </div>
    <div class="custom-container">
        <div class="row mb-3">
            <div class="col text-center">
                <div class="d-flex flex-row justify-content-center align-items-center">
                    <h6 class="regular-text red">Chi è il contraente?</h6>
                    <img class="ms-2 tooltip-icon" src="../../assets/info.svg" alt="" srcset="" data-bs-toggle="tooltip" data-bs-custom-class="custom-tooltip" data-bs-placement="right" title="Età minima 18 anni e massimo 88 anni alla scadenza del piano di versamenti.">
                </div>
            </div>
        </div>
        <form @submit.prevent="validateForm" id="formId" method="post" novalidate="true">
            <div class="row mb-3">
                <div class="col-lg-4">
                    <input v-model="formData.contractFigure.firstName" type="text" class="form-control" id="CFFirstName" placeholder="Nome" required="">
                </div>
                <div class="col-lg-4">
                    <input v-model="formData.contractFigure.lastName" type="text" class="form-control" id="CFLastName" placeholder="Cognome" required="">
                </div>
                <div class="col-lg-4">
                    <input v-model="formData.contractFigure.dateOfBirth" @change="checkAge(formData.contractFigure.dateOfBirth)" :type="formData.contractFigure.dateOfBirth == null ? 'text' : 'date'" class="form-control" id="CFDob" placeholder="Data di nascita" onfocus="(this.type='date')" required="">
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-lg-4">
                    <input v-model="formData.contractFigure.address" type="text" class="form-control" id="CFAddress" placeholder="Indirizzo" required="">
                </div>
                <div class="col-lg-4">
                    <input v-model="formData.contractFigure.email" type="text" class="form-control" id="CFEmail" placeholder="Email" required="">
                </div>
                <div class="col-lg-4">
                    <input v-model="formData.contractFigure.telephone" type="number" class="form-control" id="CFTelephone" placeholder="Telefono" required="">
                </div>
            </div>
            

            <div class="row mb-3">
                <div class="col-lg-8 text-center">
                    <div class="d-flex flex-row justify-content-center align-items-center">
                        <h6 class="regular-text red">Chi è il primo assicurato?</h6>
                        <img class="ms-2 tooltip-icon" src="../../assets/info.svg" alt="" srcset="" data-bs-toggle="tooltip" data-bs-custom-class="custom-tooltip" data-bs-placement="right" title="Età minima 18 anni e massima 88 anni alla scadenza del piano di versamenti.">
                    </div>
                    
                    <div class="border-end px-3">
                        <div class="row mb-3">
                            <div class="col-lg-6">
                                <input v-model="formData.insuredFigure.firstName" type="text" id="IFFirstName" placeholder="Nome" required="">
                            </div>
                            <div class="col-lg-6">
                                <input v-model="formData.insuredFigure.lastName" type="text" id="IFLastName" placeholder="Cognome" required="">
                            </div>
                            <div class="col-lg-6">
                                <input v-model="formData.insuredFigure.dateOfBirth" @change="checkAge(formData.insuredFigure.dateOfBirth)" :type="formData.insuredFigure.dateOfBirth == null ? 'text' : 'date'" class="form-control" id="IFDob" placeholder="Data di nascita" onfocus="(this.type='date')" required="">
                            </div>
                        </div>
                        <h6 class="regular-text red">Quali beneficiari voglio inserire nella mia polizza in caso di scomparsa?</h6>
                        <div class="row mb-3">
                            <div class="col-lg-6">
                                <input v-model="formData.beneficiaryFigure.firstName" type="text" id="BFFirstName" placeholder="Nome" required="">
                            </div>
                            <div class="col-lg-6">
                                <input v-model="formData.beneficiaryFigure.lastName" type="text" id="BFLastName" placeholder="Cognome" required="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 d-flex justify-content-center flex-column text-center">
                    <h6 class="regular-text red">A chi è rivolto il piano finalizzato?</h6>
                    <input v-model="formData.firstName" type="text" id="firstName" placeholder="Nome" disabled required>
                </div>
            </div>
            
            <div class="text-center mb-3">
                <input type="submit" value="Procedi">
            </div>
        </form>

    </div>
    <div class="container" v-if="this.errors.length > 0">
        <div class="row">
            <ul class="list-unstyled col-lg-6 offset-3">
                <li class="alert alert-danger p-2 mb-1" role="alert" :key="key" v-for="(error, key) in this.errors">
                    {{error}}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
   
    export default {
        name: 'ContractFiguresScreen',
        emits: ['go-to-event', 'go-back-event', 'save-form-data-event'],
        props: {
            formData: {
                type: Object,
                default(rawProps) {
                    return {
                        contractFigure: {
                            firstName: null,
                            lastName: null,
                            dateOfBirth: null,
                            address: null,
                            email: null,
                            telephone: null,
                        },
                        insuredFigure: {
                            firstName: null,
                            lastName: null,
                            dateOfBirth: null,
                        },
                        beneficiaryFigure: {
                            firstName: null,
                            lastName: null,
                        },
                        personType: null,
                        firstName: null,
                        dateOfBirth: null,
                    }
                }
            }
            
        },
        data() {
            return {
                errors: [],
            }
        },
        methods: {
            checkAge(birthday) {
                let today = new Date();
                let dateOfBirth = new Date(birthday);
                let days = (today.getUTCFullYear() - dateOfBirth.getUTCFullYear()) * 360 + (today.getUTCMonth() - dateOfBirth.getUTCMonth()) * 30 + (today.getUTCDate() - dateOfBirth.getUTCDate());
                let age = Math.round(days/360);
                if ((age < 18) || (age > 78)) {
                    this.errors = [];
                    this.errors.push("Età non valida");
                    return false;
                } else {
                    // Remove Error from list
                    const index = this.errors.indexOf("Età non valida");
                    if (index > -1) { 
                        this.errors.splice(index, 1); 
                    }
                }
                return true;
            },
            validateForm() {
                this.errors = [];
                if (!this.formData.contractFigure.firstName || this.formData.contractFigure.firstName == "") {
                    this.errors.push("Nome contraente mancante");
                }
                if (!this.formData.contractFigure.lastName || this.formData.contractFigure.lastName == "") {
                    this.errors.push("Cognome contraente mancante");
                }
                if (!this.formData.contractFigure.address  || this.formData.contractFigure.address == "") {
                    this.errors.push("Indirizzo contraente mancante");
                }
                if (!this.checkAge(this.formData.contractFigure.dateOfBirth)) {}
                if (!this.formData.contractFigure.dateOfBirth  || this.formData.contractFigure.dateOfBirth == "") {
                    this.errors.push("Data di nascita contraente mancante");
                }
                if (!this.formData.contractFigure.email  || this.formData.contractFigure.email == "") {
                    this.errors.push("Email contraente mancante");
                }
                if (!this.formData.contractFigure.telephone || this.formData.contractFigure.telephone == "") {
                    this.errors.push("Telefono contraente mancante");
                }
                if (!this.formData.insuredFigure.firstName || this.formData.insuredFigure.firstName == "") {
                    this.errors.push("Nome assicurato mancante");
                }
                if (!this.formData.insuredFigure.lastName || this.formData.insuredFigure.lastName == "") {
                    this.errors.push("Cognome assicurato mancante");
                }
                if (!this.formData.beneficiaryFigure.firstName || this.formData.beneficiaryFigure.firstName == "") {
                    this.errors.push("Nome beneficiario mancante");
                }
                if (!this.formData.beneficiaryFigure.lastName || this.formData.beneficiaryFigure.lastName == "") {
                    this.errors.push("Cognome beneficiario mancante");
                }
                // Save Form
                if (this.errors.length === 0) {
                    if (this.formData.contractFigure.firstName && this.formData.contractFigure.lastName && 
                        this.formData.contractFigure.dateOfBirth && this.formData.contractFigure.address && 
                        this.formData.contractFigure.email && this.formData.contractFigure.telephone && 
                        this.formData.insuredFigure.firstName && this.formData.insuredFigure.lastName && 
                        this.formData.beneficiaryFigure.firstName && this.formData.beneficiaryFigure.lastName) {
                        this.$emit('save-form-data-event', this.formData);
                        this.$emit('go-to-event', 'HowMuchScreenId');
                        return true;
                    }
                }
            }
        }
    }
</script>